import axios from 'axios';

import ConfigureHeaders from '../utils/ConfigureHeaders';

const baseURL = process.env.REACT_APP_API_CERTIFICADO;

const certificado = () => {
  const defaultOptions = {
    baseURL,
    headers: {
      Accept: 'application/json',
    },
  };

  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(config => ConfigureHeaders(config));

  return instance;
};

export default certificado();
